import momentTz from 'moment-timezone'
import _some from 'lodash/some'
import _includes from 'lodash/includes'

const ISO_DAYS_OF_WEEK = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY']
const WEEKENDS = ['SATURDAY', 'SUNDAY']
const WEEKDAYS = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY']
const DEFAULT_TZ = 'America/New_York'
const EMPTY_HOURS = []
const HOURS_FORMAT = 'HH:mm:ss'
const VALIDATE_PARSING = true

export const areWeOpenForBusiness = (tz = DEFAULT_TZ, openHours = EMPTY_HOURS, momentTzNowFunc = momentTz) => {
  return _areWeOpenForBusiness(tz, openHours, momentTzNowFunc)
}

const includesToday = (today, dayOfWeek) => {
  return dayOfWeek === today ||
      dayOfWeek === 'EVERYDAY' ||
      (dayOfWeek === 'WEEKENDS' && _includes(WEEKENDS, today)) ||
      (dayOfWeek === 'WEEKDAYS' && _includes(WEEKDAYS, today))
}

const _areWeOpenForBusiness = (tz, openHours, momentTzNowFunc) => {
  const now = momentTzNowFunc() // injected for testing: a moment-timezone() object
  const isoToday = now.tz(tz).isoWeekday()
  const isoTodayName = ISO_DAYS_OF_WEEK[isoToday - 1]
  return _some(openHours, ({ dayOfWeek, opens, closes }) => {
    if (!includesToday(isoTodayName, dayOfWeek)) {
      return false
    }

    const tzOpens = convertHourToFullDate(tz, opens, momentTzNowFunc)
    const tzCloses = convertHourToFullDate(tz, closes, momentTzNowFunc)
    return tzOpens && tzCloses && now.isBetween(tzOpens, tzCloses)
  })
}

/*

Initalize now locally and convert to desired timezone (our customer's timezone).
Then use momentTz to parse our hours, but just to get hours/minutes/seconds
Finally, modify the local time in customer's timezone to match those hours.

This is done so the comparison actually falls on the same day as the local computer.

*/
const convertHourToFullDate = (tz, hours, momentTzNowFunc) => {
  const nowInTz = momentTzNowFunc().tz(tz)
  const tzParsed = momentTz.tz(hours, HOURS_FORMAT, VALIDATE_PARSING, tz)
  if (!tzParsed.isValid()) {
    return
  } else {
    return nowInTz.hours(tzParsed.hours())
      .minutes(tzParsed.minutes())
      .seconds(tzParsed.seconds())
  }
}



// WEBPACK FOOTER //
// ./src/scripts/utils/OpenHoursHelper.js